var map = {
	"./Payroll/Item-allowance.js": "e367",
	"./Payroll/first-cycle-paid.js": "fa87",
	"./Payroll/fixed-allowance.js": "3481",
	"./Payroll/fixed-incentive-bonus.js": "f5e1",
	"./Payroll/item-compensate.js": "d889",
	"./Payroll/item-deduction.js": "1cc8",
	"./Payroll/item-incentive-bonus.js": "b087",
	"./Payroll/item-overtime.js": "e10f",
	"./Payroll/monthly-allowance.js": "2165",
	"./Payroll/monthly-compensate.js": "e98e",
	"./Payroll/monthly-deduction.js": "4f34",
	"./Payroll/monthly-incentive-bonus.js": "07d6",
	"./Payroll/monthly-over-time.js": "798c",
	"./Payroll/overtime-rule-by-shift.js": "2671",
	"./Payroll/payroll-calculation.js": "03e0",
	"./Payroll/payroll-template.js": "153f",
	"./Payroll/payslip-template.js": "af2e",
	"./Payroll/pension-contribution-wage.js": "fd7ea",
	"./Payroll/pension-rate.js": "7e61",
	"./Payroll/tax-range.js": "8e0e",
	"./accounting/coa-category.js": "4451",
	"./accounting/coa-mapping.js": "769b",
	"./accounting/coa-setup.js": "f6ec",
	"./accounting/journal-entry.js": "827c",
	"./auth/role.js": "0943",
	"./auth/user.js": "9c26",
	"./corporate/branch.js": "d01a",
	"./corporate/citizenship-statistic.js": "ad5a",
	"./corporate/city-province.js": "275f",
	"./corporate/company.js": "1644",
	"./corporate/khan-district.js": "a02a",
	"./corporate/phum-village.js": "1d29",
	"./corporate/sangkat-commune.js": "2410",
	"./credit-operation/customer-loan-purpose.js": "bf3a",
	"./credit-operation/customer-loan-request.js": "bb9a",
	"./credit-operation/customer.js": "f141",
	"./credit-operation/eod.js": "9f21",
	"./credit-operation/loan-currency.js": "9487",
	"./credit-operation/loan-disbursement.js": "8c4c",
	"./credit-operation/loan-recovery.js": "4d3e",
	"./credit-operation/loan-rejection.js": "ae06",
	"./credit-operation/loan-repayment.js": "523d",
	"./credit-operation/loan-transfer.js": "6bf5",
	"./credit-operation/loan-type-user-defined-rates.js": "005b",
	"./credit-operation/loan-type.js": "ec79",
	"./credit-operation/loan-write-off.js": "89b9",
	"./credit-operation/monitoring-question-category.js": "9dca",
	"./credit-operation/monitoring-question.js": "10f3",
	"./credit-operation/monitoring-survey.js": "82e9",
	"./credit-operation/motor-risk.js": "34e8",
	"./credit-operation/motor-withdraw.js": "76cf",
	"./credit-operation/occupation.js": "6939",
	"./exchange-rate/currency-exchange.js": "e9bc",
	"./exchange-rate/currency.js": "3bab",
	"./finance/bank-profile.js": "e055",
	"./finance/cash-request.js": "1ec3",
	"./finance/cash-transfer.js": "34f4",
	"./home.js": "3165",
	"./human-resource/attendance-device.js": "c41a",
	"./human-resource/basic-salary-formula.js": "a12d",
	"./human-resource/basic-salary.js": "bfd9",
	"./human-resource/daily-attendance.js": "bd63",
	"./human-resource/employee.js": "07f8",
	"./human-resource/holiday-rule.js": "fd65",
	"./human-resource/holiday.js": "922b",
	"./human-resource/job-detail.js": "ea38",
	"./human-resource/job-level.js": "1f00",
	"./human-resource/job-title.js": "4634",
	"./human-resource/leave-initial-balance.js": "f053",
	"./human-resource/leave-record.js": "3b98",
	"./human-resource/leave-rule.js": "5c6d",
	"./human-resource/leave-sub-item.js": "7d95",
	"./human-resource/nationality.js": "6827",
	"./human-resource/organizational-chart.js": "7c12",
	"./human-resource/organizational-structure.js": "9f45",
	"./human-resource/payroll-cycle-date.js": "cdc0",
	"./human-resource/payroll-cycle.js": "95f6",
	"./human-resource/position-hierarchy.js": "dc12",
	"./human-resource/shift-management.js": "8603",
	"./human-resource/work-schedule.js": "19f7",
	"./login.js": "8cc5",
	"./payroll/pay-user-variable.js": "76c4",
	"./report/accounting.js": "b2ce",
	"./report/credit-operation.js": "2c41",
	"./report/finance.js": "a251",
	"./report/human-resource.js": "3d16",
	"./report/payroll.js": "d052",
	"./setting/approval-flow.js": "1cdb",
	"./setting/system.js": "97c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61d6";